// project imports
import MainLayout from "layout/MainLayout";
import Loadable from "shared/ui/Loadable";
import AuthGuard from "shared/utils/route-guard/AuthGuard";
import lazyWithLogout from "shared/utils/lazyWithLogout";
//types
import { Route } from "shared/types";
import { ActionList } from "shared/types/actions";
import { ERoles } from "shared/types/roles";

//users
const UsersOrganization = Loadable(
  lazyWithLogout(
    () => import("features/organization/components/OrganizationList"),
  ),
);
const UsersOrganizationDetails = Loadable(
  lazyWithLogout(
    () => import("features/organization/components/OrganizationDetails"),
  ),
);
const UsersOrganizationEdit = Loadable(
  lazyWithLogout(
    () => import("features/organization/components/EditOrganization"),
  ),
);
const UsersOrganizationCreate = Loadable(
  lazyWithLogout(
    () => import("features/organization/components/CreateOrganization"),
  ),
);

const UsersEmployees = Loadable(
  lazyWithLogout(() => import("features/employee/components/EmployeeList")),
);
const UsersEmployeeDetails = Loadable(
  lazyWithLogout(() => import("features/employee/components/EmployeeDetails")),
);

const UserLeads = Loadable(
  lazyWithLogout(() => import("features/lead/components/LeadList")),
);
const UserDebtors = Loadable(
  lazyWithLogout(() => import("features/debtor/components/DebtorList")),
);

//dashboard

const DashboardApplications = Loadable(
  lazyWithLogout(
    () => import("features/application/components/ApplicationList"),
  ),
);
const DashboardCreateApplications = Loadable(
  lazyWithLogout(
    () => import("features/application/components/CreateApplication"),
  ),
);
const DashboardApplicationDetails = Loadable(
  lazyWithLogout(
    () => import("features/application/components/ApplicationDetails"),
  ),
);
const DashboardSignatures = Loadable(
  lazyWithLogout(() => import("features/signature/components/SignatureList")),
);
const DashboardSignatureDetails = Loadable(
  lazyWithLogout(
    () => import("features/signature/components/SignatureDetails"),
  ),
);

//tools
const TemplateParameterList = Loadable(
  lazyWithLogout(
    () => import("features/template/components/TemplateParameterList"),
  ),
);
const AnalyticsView = Loadable(
  lazyWithLogout(
    () => import("features/analyticalTreeMap/components/AnalyticsView"),
  ),
);
const AnalyticalReportView = Loadable(
  lazyWithLogout(
    () => import("features/analyticalReport/components/AnalyticalReportView"),
  ),
);

const Error = Loadable(lazyWithLogout(() => import("routes/Error")));

const MainRoutes: Route = {
  path: "/",
  element: (
    <AuthGuard>
      <MainLayout />
    </AuthGuard>
  ),
  errorElement: <Error />,
  children: [
    {
      path: "/users/organizations",
      element: <UsersOrganization />,
    },
    {
      path: "/users/organizations/organization-details/:id",
      element: <UsersOrganizationDetails />,
    },
    {
      path: "/users/organizations/organization-details/:organizationId/:orgBin/employee/:id",
      element: <UsersEmployeeDetails />,
    },
    {
      path: "/users/organizations/organization-edit/:id",
      element: <UsersOrganizationEdit />,
      actions: [
        ActionList.clients.fetch_client,
        ActionList.clients.update_client,
      ],
    },
    {
      path: "/users/organizations/organization-create",
      element: <UsersOrganizationCreate />,
      actions: [ActionList.clients.create_client],
    },
    {
      path: "/users/employees",
      element: <UsersEmployees />,
    },
    {
      path: "/users/employees/employee-details/:id",
      element: <UsersEmployeeDetails />,
    },
    {
      path: "/users/leads",
      element: <UserLeads />,
      actions: [ActionList.employees.fetch_all_employees],
    },
    {
      path: "/users/debtors",
      element: <UserDebtors />,
      actions: [ActionList.employees.fetch_all_employees],
    },
    {
      path: "/dashboard/applications",
      element: <DashboardApplications />,
      actions: [
        ActionList.applications.fetch_all_applications,
        ActionList.applications.fetch_all_applications_for_current_user,
      ],
    },
    {
      path: "/dashboard/applications/create-application/:id/:ordinalNumber",
      element: <DashboardCreateApplications />,
      actions: [ActionList.applications.create_application],
    },
    {
      path: "/dashboard/applications/edit-application/:id/:ordinalNumber",
      element: <DashboardCreateApplications />,
      actions: [ActionList.applications.create_application],
    },
    {
      path: "/dashboard/applications/application-details/:id/:ordinalNumber",
      element: <DashboardApplicationDetails />,
      actions: [
        ActionList.applications.fetch_application,
        ActionList.applications.fetch_application_status_history,
      ],
    },
    {
      path: "/dashboard/signatures",
      element: <DashboardSignatures />,
    },
    {
      path: "/dashboard/signatures/signature-details/:id",
      element: <DashboardSignatureDetails />,
    },

    {
      path: "/tools/template-parameters",
      element: <TemplateParameterList />,
      roles: [ERoles.director],
    },
    // {
    //   path: "/tools/analytics-treemap",
    //   element: <AnalyticsView />,
    //   roles: [ERoles.director],
    // },
    {
      path: "/tools/analytical-report",
      element: <AnalyticalReportView />,
      roles: [ERoles.director],
    },
  ],
};

export default MainRoutes;
